module.exports = __webpack_public_path__ + "static/media/scroll-old.71831612.svg";